import { ARTICLE_IDS } from 'common/constants/constants';
import round from 'lodash/round';

export default function generateMetricsArray(
  organizationCodeChanges,
  numOfDaysInIteration,
  organizationDeploymentFrequency,
  prOpenRate,
  reviewDepth
) {
  return [
    {
      label: 'CODE CHANGES RATE',
      units: 'Changes/day',
      value:
        organizationCodeChanges.value && numOfDaysInIteration
          ? (organizationCodeChanges.value / numOfDaysInIteration).toFixed(1)
          : 0,
      min: 140,
      max: 2930,
      articleId: ARTICLE_IDS.CODE_CHANGES_RATE
    },
    {
      label: 'DEPLOY FREQUENCY',
      units: 'Releases/day',
      value: organizationDeploymentFrequency,
      min: 0,
      max: 2,
      articleId: ARTICLE_IDS.DEPLOYMENT_FREQ
    },
    {
      label: 'PR OPEN RATE',
      units: 'PRs/day',
      value: prOpenRate,
      min: 0,
      max: 4,
      articleId: ARTICLE_IDS.PR_OPEN_RATE
    },
    {
      label: 'REVIEW DEPTH',
      units: 'Comments/PR',
      value: reviewDepth ? round(reviewDepth, 1) : '-',
      min: 0,
      max: 6,
      articleId: ARTICLE_IDS.REVIEW_DEPTH
    }
  ];
}
